/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { MergeChannelService } from "./merge-channel.service";
import { TabMergeService } from "./tab-merge.service";

@NgModule({
   declarations: [],
   providers: [MergeChannelService, TabMergeService]
})
export class TabMergeModule {}
